module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "suc-txt"
  }, [_vm._v("交易成功！3500平台币已到达您的账户")]), _vm._v(" "), _c('div', {
    staticClass: "suc-back",
    on: {
      "click": _vm.gofinance
    }
  }, [_vm._v("返回查看")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3787726","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/finance/chargeSuc.vue
// module id = 921
// module chunks = 1